import { LOCALE } from 'src/providers/types';
import { badgeVariants } from 'src/registry/ui/Badge';

import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import type { VariantProps } from 'class-variance-authority';
import type { MessageDescriptor } from 'react-intl';

export interface BadgeColors {
    background?: string;
    borderColor?: string;
    color?: string;
    iconColor?: string;
}

// A definition of a badge option. We map them in an object and then access them based on an enum
// and style them as defined in this interface.
export interface BadgeOption extends VariantProps<typeof badgeVariants> {
    label: MessageDescriptor;
    icon?: IconProp;
    iconSize?: SizeProp;
    color?: BadgeColors;
}

export type BadgeOptions = {
    [key: string]: BadgeOption;
};

export type Option = {
    value: string;
    label: string;
};

export type Translation = {
    language: LOCALE;
    name: string;
    description?: string;
};

export type TranslationsWithId = {
    id: string;
    translations: Translation[];
};

export enum CURRENCY {
    EUR = 'EUR',
}

export type Options = Option[];
